/// Reformatar enquanto se digita sem brigar com o cursor. Dois cuidados que todo campo com máscara
/// precisa e costuma esquecer:
///
/// - apagar um caractere da máscara (o hífen, o parêntese) não muda os dígitos, e a máscara o
///   devolveria no mesmo instante — o Backspace pareceria quebrado. Então apagar a máscara apaga o
///   dígito que vem antes dela;
/// - o cursor volta para depois do mesmo dígito em que estava, não para o fim do texto, senão
///   corrigir um número no meio obriga a reposicionar a cada tecla.
export function remask(
  raw: string,
  previous: string,
  caret: number,
  format: (digits: string, international: boolean) => string,
): { text: string; caret: number } {
  let working = raw;
  let position = caret;
  if (onlyDigits(raw) === onlyDigits(previous) && raw.length < previous.length) {
    const before = working.slice(0, position);
    const index = before.search(/\d\D*$/u);
    if (index >= 0) {
      working = working.slice(0, index) + working.slice(index + 1);
      position = index;
    }
  }
  const digitsBefore = onlyDigits(working.slice(0, position)).length;
  const international = working.trimStart().startsWith('+');
  const text = format(onlyDigits(working), international);
  return { text, caret: caretAfterDigits(text, digitsBefore) };
}

export function onlyDigits(value: string): string {
  return value.replace(/\D/gu, '');
}

function caretAfterDigits(text: string, count: number): number {
  if (count === 0) return text.startsWith('+') ? 1 : 0;
  let seen = 0;
  for (let index = 0; index < text.length; index += 1) {
    if (/\d/u.test(text[index]!)) seen += 1;
    if (seen === count) return index + 1;
  }
  return text.length;
}
